<template>
  <div>
    <DialogPrime
      :header="$t('addMainEngineEmissionsComponentHeader')"
      v-model:visible="displayBasic"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '75vw' }"
    >
      <div class="formgrid grid">
        <div class="field col-12 md:col-6">
          <label>{{ $t("name") }}</label>
          <InputTextPrime id="inputField" v-model="name" :class="{ 'p-invalid': v$.name.$invalid && submitted }" />
          <small v-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response" class="p-error">{{
            v$.name.required.$message.replace("Value", "Name")
          }}</small>
        </div>
        <div class="field col-12 md:col-3">
          <label>{{ $t("propulsionType") }}</label>
          <DropdownPrime
            v-model="propulsionType"
            :options="propulsionTypeOptions"
            optionLabel="name"
            placeholder="Tipo de Propulsión"
            v-on:change="onPropulsionTypeChanged"
            :class="{ 'p-invalid': v$.propulsionType.$invalid && submitted }"
            id="inputField"
          ></DropdownPrime>
          <small
            v-if="(v$.propulsionType.$invalid && submitted) || v$.propulsionType.$pending.$response"
            class="p-error"
            >{{ v$.propulsionType.required.$message.replace("Value", "Propulsion Type ") }}</small
          >
        </div>

        <div class="field col-12 md:col-3">
          <label>{{ $t("fuelType") }}</label>
          <DropdownPrime
            v-model="fuelType"
            :options="fuelTypeOptions"
            optionLabel="name"
            placeholder="Tipo de Combustible"
            :class="{ 'p-invalid': v$.fuelType.$invalid && submitted }"
            id="inputField"
          ></DropdownPrime>
          <small v-if="(v$.fuelType.$invalid && submitted) || v$.fuelType.$pending.$response" class="p-error">{{
            v$.fuelType.required.$message.replace("Value", "Fuel Type ")
          }}</small>
        </div>
        <div class="field col-12 md:col-6">
          <label
            for=""
            v-if="
              (propulsionType &&
                propulsionType.code != steamTurbineCode &&
                propulsionType &&
                propulsionType.code != dieselElectricCode &&
                propulsionType &&
                propulsionType.code != dieselElectricDualCode) ||
              propulsionType === null
            "
          >
            {{ $t("mcrme") }} - <strong>MCR<sub>ME</sub></strong> (kw)</label
          >
          <label for="" v-if="propulsionType && propulsionType.code === steamTurbineCode">
            {{ $t("mcrme") }} - <strong>MCR<sub>turbina</sub></strong> (kw)</label
          >
          <label
            for=""
            v-if="
              propulsionType &&
              (propulsionType.code === dieselElectricCode || propulsionType.code === dieselElectricDualCode)
            "
            >{{ $t("mcrme") }} - <strong>MPP<sub>motor</sub></strong> (kw)</label
          >
          <InputTextPrime
            type="number"
            id="inputField"
            v-model="mcrme"
            mode="decimal"
            :class="{ 'p-invalid': v$.mcrme.$invalid && submitted }"
            :style="{ width: '35vw' }"
          />
          <small v-if="(v$.mcrme.$invalid && submitted) || v$.mcrme.$pending.$response" class="p-error">{{
            v$.mcrme.required.$message.replace("Value", "Rated installed power")
          }}</small>
        </div>

        <div
          class="field col-12 md:col-6"
          v-if="(propulsionType && propulsionType.code != steamTurbineCode) || propulsionType === null"
        >
          <label for=""
            >{{ $t("certifiedFuelConsumption") }} - <strong> SFC<sub>ME</sub></strong> (g/kWh)</label
          >
          <InputTextPrime
            type="number"
            id="inputField"
            v-model="sfcme"
            :class="{ 'p-invalid': v$.sfcme.$invalid && submitted }"
            :style="{ width: '35vw' }"
          />
          <small v-if="(v$.sfcme.$invalid && submitted) || v$.sfcme.$pending.$response" class="p-error">{{
            v$.sfcme.required.$message.replace("Value", "Certified specific fuel consumption")
          }}</small>
        </div>
        <div class="field col-12 md:col-6" v-if="propulsionType && propulsionType.code === steamTurbineCode">
          <label for="fuelConsumption"
            ><strong>{{ $t("fuelConsumption") }}</strong> (g/h)</label
          >
          <InputTextPrime
            type="number"
            id="inputField"
            v-model="fuelConsumption"
            :class="{ 'p-invalid': v$.fuelConsumption.$invalid && submitted }"
            :style="{ width: '35vw' }"
          />
          <small
            v-if="(v$.fuelConsumption.$invalid && submitted) || v$.fuelConsumption.$pending.$response"
            class="p-error"
            >{{ v$.fuelConsumption.required.$message.replace("Value", "Fuel Consumption") }}</small
          >
        </div>
        <div class="field col-12 md:col-2">
          <label for="shaftGeneratorElement">{{ $t("shaftGenerator") }}</label>
          <SelectButton
            id="shaftGeneratorElement"
            v-model="shaftGenerator"
            @change="selectChange('shaft')"
            :options="shaftGeneratorOptions"
            optionLabel="name"
            :disabled="!(propulsionType && propulsionType.code != dieselElectricCode)"
          />
        </div>
        <div
          v-if="
            propulsionType &&
            propulsionType.code != dieselElectricCode &&
            shaftGenerator &&
            shaftGenerator.code === 'YES'
          "
          class="field col-12 md:col-4"
        >
          <label for="mcrptoElement">
            {{ $t("mcrpto") }} - <strong>MCR<sub>PTO</sub></strong> (kw)</label
          >
          <InputTextPrime
            type="number"
            id="inputField"
            v-model="mcrpto"
            :class="{ 'p-invalid': v$.mcrpto.$invalid && submitted }"
            :style="{ width: '35vw' }"
          />
          <small v-if="(v$.mcrpto.$invalid && submitted) || v$.mcrpto.$pending.$response" class="p-error">{{
            v$.mcrpto.required.$message.replace("Value", "Rated power of shaft generator")
          }}</small>
        </div>
        <div class="field col-12 md:col-10" v-else></div>
        <div
          class="field col-12 md:col-5"
          v-if="
            propulsionType &&
            propulsionType.code != dieselElectricCode &&
            shaftGenerator &&
            shaftGenerator.code === 'YES'
          "
        ></div>

        <div class="field col-12 md:col-2">
          <label for="powerLimitElement">{{ $t("powerLimit") }}</label>
          <SelectButton
            id="powerLimitElement"
            v-model="powerLimit"
            @change="selectChange('powerLimit')"
            :options="powerLimitOptions"
            optionLabel="name"
          />
        </div>
        <div class="field col-12 md:col-4" v-if="powerLimit.code === 'YES'">
          <label for="inputField"> {{ getPowerLimitLabel() }} </label>
          <InputTextPrime
            type="number"
            id="inputField"
            v-model="powerLimitValue"
            :class="{ 'p-invalid': v$.powerLimitValue.$invalid && submitted }"
          />
          <small
            v-if="(v$.powerLimitValue.$invalid && submitted) || v$.powerLimitValue.$pending.$response"
            class="p-error"
            >{{ v$.powerLimitValue.required.$message.replace("Value", "Rated power of shaft generator") }}</small
          >
        </div>
        <div class="field col-12 md:col-6" v-if="powerLimit.code === 'YES'">
          <p>{{ $t("powerLimitType") }}</p>
          <DropdownPrime
            v-model="powerLimitType"
            :options="powerLimitTypeOptions"
            optionLabel="name"
            placeholder="Select power limit type"
            class="col-12 md:col-12"
          ></DropdownPrime>
        </div>
        <div class="field col-12 md:col-10" v-else></div>

        <div class="field col-12 md:col-6" v-if="isDual()">
          <label for="vliquidElement"
            >{{ $t("vliquid") }} -
            <strong
              >V<sub>{{ $t("liquid") }}</sub></strong
            >
            (m&#179;)</label
          >
          <InputTextPrime
            type="number"
            id="inputField"
            v-model="vliquid"
            :class="{ 'p-invalid': v$.vliquid.$invalid && submitted }"
            :style="{ width: '35vw' }"
          />
          <small v-if="(v$.vliquid.$invalid && submitted) || v$.vliquid.$pending.$response" class="p-error">{{
            v$.vliquid.required.$message.replace("Value", "Total net liquid fuel capacity")
          }}</small>
        </div>
        <div class="field col-12 md:col-6" v-if="isDual()">
          <label for="vgasElement"
            >{{ $t("vgas") }} - <strong>V<sub>gas</sub></strong> (m&#179;)</label    
          >
          <InputTextPrime
            type="number"
            id="inputField"
            v-model="vgas"
            :class="{ 'p-invalid': v$.vgas.$invalid && submitted }"
            :style="{ width: '35vw' }"
          />
          <small v-if="(v$.vgas.$invalid && submitted) || v$.vgas.$pending.$response" class="p-error">{{
            v$.vgas.required.$message.replace("Value", "Total net gas fuel capacity")
          }}</small>
        </div>
        <div class="field col-12 md:col-6" v-if="isDual()">
          <label for="kliquidElement"
            >{{ $t("kliquid") }} -
            <strong
              >K<sub>{{ $t("liquid") }}</sub></strong
            >
            </label
          >
          <InputTextPrime
            type="number"
            id="inputField"
            v-model="kliquid"
            :class="{ 'p-invalid': v$.kliquid.$invalid && submitted }"
            :style="{ width: '35vw' }"
          />
          <small v-if="(v$.kliquid.$invalid && submitted) || v$.kliquid.$pending.$response" class="p-error">{{
            v$.kliquid.required.$message.replace("Value", "Filling rate for liquid fuel tanks")
          }}</small>
        </div>
        <div class="field col-12 md:col-6" v-if="isDual()">
          <label for="kgasElement"
            >{{ $t("kgas") }} - <strong>K<sub>gas</sub></strong></label
          >
          <InputTextPrime
            type="number"
            id="inputField"
            v-model="kgas"
            :class="{ 'p-invalid': v$.kgas.$invalid && submitted }"
            :style="{ width: '35vw' }"
          />
          <small v-if="(v$.kgas.$invalid && submitted) || v$.kgas.$pending.$response" class="p-error">{{
            v$.kgas.required.$message.replace("Value", "Filling rate for gas fuel tanks")
          }}</small>
        </div>
        <div class="field col-12 md:col-6" v-if="isDual()">
          <label for="sfcliquidElement"
            >{{ $t("sfcLiquid") }} –
            <strong
              >SFC<sub>{{ $t("liquid") }}</sub></strong
            >
            (g/kWh)</label
          >
          <InputTextPrime
            type="number"
            id="inputField"
            v-model="sfcliquid"
            :class="{ 'p-invalid': v$.sfcliquid.$invalid && submitted }"
            :style="{ width: '35vw' }"
          />
          <small v-if="(v$.sfcliquid.$invalid && submitted) || v$.sfcliquid.$pending.$response" class="p-error">{{
            v$.sfcliquid.required.$message.replace("Value", "Certified specific liquid fuel consumption")
          }}</small>
        </div>
        <div class="field col-12 md:col-6" v-if="isDual()">
          <label for="sfcgasElement"
            >{{ $t("sfcGas") }} - <strong>SFC<sub>gas</sub></strong> (g/kWh)</label
          >
          <InputTextPrime
            type="number"
            id="inputField"
            v-model="sfcgas"
            :class="{ 'p-invalid': v$.sfcgas.$invalid && submitted }"
            :style="{ width: '35vw' }"
          />
          <small v-if="(v$.sfcgas.$invalid && submitted) || v$.sfcgas.$pending.$response" class="p-error">{{
            v$.sfcgas.required.$message.replace("Value", "Certified specific gas fuel consumption")
          }}</small>
        </div>
        <div class="field col-12 md:col-6" v-if="isDual()">
          <label for="sfcmepilotElement"
            >{{ $t("sfcmePilot") }} – <strong>SFC<sub>MEpilot</sub></strong> (g/kWh)</label
          >
          <InputTextPrime
            type="number"
            id="inputField"
            v-model="sfcmepilot"
            :class="{ 'p-invalid': v$.sfcmepilot.$invalid && submitted }"
            :style="{ width: '35vw' }"
          />
          <small v-if="(v$.sfcmepilot.$invalid && submitted) || v$.sfcmepilot.$pending.$response" class="p-error">{{
            v$.sfcmepilot.required.$message.replace("Value", "Certified specific pilot fuel consumption")
          }}</small>
        </div>
        <div class="field col-12 md:col-6" v-if="isDual()">
          <p>{{ $t("secondFuel") }}</p>
          <DropdownPrime
            v-model="secondFuelType"
            :options="fuelTypeOptions"
            optionLabel="name"
            placeholder="Select second fuel type"
            id="secondFuelTypeElement"
          ></DropdownPrime>
        </div>
      </div>
      <template #footer>
        <ButtonPrime :label="$t('cancel')" icon="pi pi-times" @click="closeBasic" class="p-button-text" />
        <ButtonPrime :label="$t('confirm')" icon="pi pi-check" @click="saveAndClose" autofocus />
      </template>
    </DialogPrime>
  </div>
</template>

<script>
import { propulsionTypeCodes } from "../utils/constants";
import ShipPartService from "@/services/ShipPartService";
import ParametricTableService from "@/services/ParametricTableService";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import store from "@/store/index";
import utils from "@/utils/configuration/config.js";

export default {
  name: "AddMainEngineEmissionsComponent",
  data: () => {
    return {
      id: null,
      name: "",
      displayBasic: false,
      propulsionType: null,
      propulsionTypeOptions: [],
      powerLimit: { name: "No", code: "NO" },
      powerLimitOptions: [],
      powerLimitType: {},
      powerLimitTypeOptions: [],
      powerLimitValue: 0,
      fuelType: null,
      fuelTypeOptions: [],
      secondFuelType: null,
      sfcme: 190,
      fuelConsumption: 0,
      shaftGenerator: { name: "No", code: "NO" },
      shaftGeneratorName: "",
      shaftGeneratorOptions: [],
      vgas: 0,
      kgas: 0,
      sfcgas: 0,
      vliquid: 0,
      kliquid: 0,
      sfcliquid: 0,
      sfcmepilot: 0,
      mcrpto: 0,
      mcrme: 0,
      steamTurbineCode: propulsionTypeCodes.SteamTurbine,
      dieselElectricCode: propulsionTypeCodes.DieselElectric,
      dieselElectricDualCode: propulsionTypeCodes.DieselElectricDual,
      dualCode: propulsionTypeCodes.Dual,
      submitted: false,
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      name: { required },
      propulsionType: { required },
      fuelType: { required },
      mcrme: { required },
      sfcme: { required },
      fuelConsumption: { required },
      shaftGenerator: { required },
      mcrpto: { required },
      powerLimitValue: { required },
      vliquid: { required },
      kliquid: { required },
      sfcliquid: { required },
      vgas: { required },
      kgas: { required },
      sfcgas: { required },
      sfcmepilot: { required },
    };
  },
  props: {
    editElementId: Object,
  },

  watch: {
    editElementId: function (newVal, oldVal) {
      // watch it
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
      this.id = newVal.id;
      this.name = newVal.name;

      this.propulsionType = this.findElementInOptions(newVal.propulsionType, this.propulsionTypeOptions);
      this.fuelType = this.findElementInOptions(newVal.fuelType, this.fuelTypeOptions);

      newVal.mcrpto != undefined ? (this.mcrpto = newVal.mcrpto) : (this.mcrpto = 0);
      newVal.powerLimitValue != undefined
        ? (this.powerLimitValue = newVal.powerLimitValue)
        : (this.powerLimitValue = 0);

      this.powerLimit = this.findElementInOptions(newVal.powerLimit ? "YES" : "NO", this.powerLimitOptions);
      this.shaftGenerator = this.findElementInOptions(newVal.shaftGenerator ? "YES" : "NO", this.shaftGeneratorOptions);
      this.powerLimitType = this.findElementInOptions(newVal.powerLimitType, this.powerLimitTypeOptions);

      this.secondFuelType = this.findElementInOptions(newVal.secondFuelType, this.fuelTypeOptions);
      this.fuelConsumption = newVal.fuelConsumption;
      newVal.sfcme != undefined ? (this.sfcme = newVal.sfcme) : (this.sfcme = 190);
      this.mcrme = newVal.mcrme;

      newVal.fuelConsumption != undefined
        ? (this.fuelConsumption = newVal.fuelConsumption)
        : (this.fuelConsumption = 0);
      newVal.ratedsecondFuelType != undefined
        ? (this.ratedsecondFuelType = newVal.ratedsecondFuelType)
        : (this.ratedsecondFuelType = 0);

      newVal.vgas != undefined ? (this.vgas = newVal.vgas) : (this.vgas = 0);
      newVal.kgas != undefined ? (this.kgas = newVal.kgas) : (this.kgas = 0);
      newVal.sfcgas != undefined ? (this.sfcgas = newVal.sfcgas) : (this.sfcgas = 0);
      newVal.vliquid != undefined ? (this.vliquid = newVal.vliquid) : (this.vliquid = 0);
      newVal.kliquid != undefined ? (this.kliquid = newVal.kliquid) : (this.kliquid = 0);
      newVal.sfcliquid != undefined ? (this.sfcliquid = newVal.sfcliquid) : (this.sfcliquid = 0);
      newVal.sfcmepilot != undefined ? (this.sfcmepilot = newVal.sfcmepilot) : (this.sfcmepilot = 0);

      this.displayBasic = true;
    },
  },

  created() {
    ParametricTableService.getInstance().getParametricTable(utils.config.firebaseConfig.parametricVersion);
  },
  mounted() {
    console.log("Propulsion Type antes", this.propulsionTypeOptions);
    const parametricTables = ParametricTableService.getInstance().getParametricTable(
      utils.config.firebaseConfig.parametricVersion
    );
    console.log("parametricTables", parametricTables);
    this.propulsionTypeOptions = parametricTables.propulsionType;
    this.fuelTypeOptions = parametricTables.fuelType;
    this.powerLimitOptions = parametricTables.yesNoType;
    this.shaftGeneratorOptions = parametricTables.yesNoType;
    this.powerLimitTypeOptions = parametricTables.powerLimitType;
    console.log("Propulsion Type después", this.propulsionTypeOptions);
  },
  methods: {
    getPowerLimitLabel() {
      let result = "";
      if (
        this.propulsionType.code === propulsionTypeCodes.LiquidFuelEngine ||
        this.propulsionType.code === propulsionTypeCodes.GasEngine ||
        this.propulsionType.code === propulsionTypeCodes.Dual
      ) {
        result = "MCRlim";
      } else if (this.propulsionType.code === propulsionTypeCodes.SteamTurbine) {
        result = "MCRturbinalim";
      } else {
        result = "MPPmotorlim";
      }

      return result;
    },
    onPropulsionTypeChanged(event) {
      const parametricTables = ParametricTableService.getInstance().getParametricTable(
        utils.config.firebaseConfig.parametricVersion
      );

      this.fuelTypeOptions = [];
      parametricTables.fuelType.forEach((fuelType) => {
        if (event.value.fuelTypesValid.includes(fuelType.code)) {
          this.fuelTypeOptions.push(fuelType);
        }
      });
    },
    closeBasic() {
      this.displayBasic = false;
    },
    async saveAndClose() {
      console.log("AddShipPartComponent-saveAndClose", this.name);
      this.handleSubmit();
      const result = await this.v$.$validate();

      if (!result) {
        this.$toast.add({
          severity: "error",
          summary: "Error no se han añadido todos los campos.",
        });
      } else {
        this.submitted = false;
        this.$toast.add({
          closable: false,
          severity: "success",
          summary: "MainEngineEmissions saved",
          life: 3000,
        });
        const newPart = {
          id: this.id,
          name: this.name,
          propulsionType: this.propulsionType ? this.propulsionType.code : "",
          fuelType: this.fuelType ? this.fuelType.code : "",
          secondFuelType: this.secondFuelType && this.secondFuelType.code ? this.secondFuelType.code : null,
          powerLimit: this.powerLimit ? this.powerLimit.code === "YES" : false,
          powerLimitValue: this.powerLimitValue ? this.powerLimitValue : 0,
          sfcme: this.sfcme ? this.sfcme : 0,
          fuelConsumption: this.fuelConsumption ? this.fuelConsumption : 0,
          shaftGenerator: this.shaftGenerator ? this.shaftGenerator.code === "YES" : false,
          mcrpto: this.mcrpto ? this.mcrpto : 0,
          vgas: this.vgas ? this.vgas : 0,
          kgas: this.kgas ? this.kgas : 0,
          sfcgas: this.sfcgas ? this.sfcgas : 0,
          vliquid: this.vliquid ? this.vliquid : 0,
          kliquid: this.kliquid ? this.kliquid : 0,
          sfcliquid: this.sfcliquid ? this.sfcliquid : 0,
          sfcmepilot: this.sfcmepilot ? this.sfcmepilot : 0,
          mcrme: this.mcrme ? this.mcrme : 0,
          powerLimitType: this.powerLimitType && this.powerLimitType.code ? this.powerLimitType.code : "",
        };

        const parametricTables = ParametricTableService.getInstance().getParametricTable(
          utils.config.firebaseConfig.parametricVersion
        );
        var parametricTablesObj = {
          fuelType: parametricTables.fuelType,
        };

        const errors = ShipPartService.getInstance().saveMainEnginePart(
          store.getters.currentShip,
          store.getters.currentConfiguration,
          newPart,
          parametricTablesObj
        );

        if (errors === "") {
          this.displayBasic = false;
          this.$emit("savedElement", "Main engine", !this.id || this.id === "");
        } else {
          this.$emit("errorSavingElement", "Main engine", errors);
        }
      }
    },
    isDual() {
      return (
        this.propulsionType &&
        (this.propulsionType.code === this.dualCode || this.propulsionType.code === this.dieselElectricDualCode)
      );
    },
    editConfig() {
      console.log("editConfig");
      this.displayBasic = true;
    },
    eventScroll() {},
    findElementInOptions(code, options) {
      console.log("findElementInOptions", code, options);
      var result = {};
      options.forEach((option) => {
        if (option.code === code) {
          result = option;
        }
      });
      return result;
    },
    selectChange(component) {
      if (component == "shaft") {
        if (this.shaftGenerator.name == "Yes") {
          this.mcrpto = "";
        } else {
          this.mcrpto = 0;
        }
      } else if (component == "powerLimit") {
        if (this.powerLimit.name == "Yes") {
          this.powerLimitValue = "";
        } else {
          this.powerLimitValue = 0;
        }
      }
    },
    handleSubmit() {
      this.submitted = true;

      this.toggleDialog();
    },
    toggleDialog() {
      this.showMessage = !this.showMessage;

      if (!this.showMessage) {
        this.resetForm();
      }
    },
    resetForm() {},
  },
};
</script>
<style scoped>
.p-button {
  margin: 10px !important;
}
.field {
  margin-bottom: 15px !important;
}

#inputField {
  width: 100%;
}
.p-inputtext .p-component .p-inputnumber-input .p-inputnumber-input {
  width: 100%;
}
#secondFuelType {
  margin-top: 25px !important;
}
</style>
